export const defaultProps = {
  easing: "cubic-bezier(0.5, 0, 0, 1)",
  distance: "30px",
  duration: 1000,
  desktop: true,
  mobile: true,
};

export const targetElements = [
  {
    element: ".section-title",
    animation: {
      delay: 300,
      distance: "0px",
      origin: "bottom",
    },
  },
  {
    element: ".about-wrapper__image",
    animation: {
      delay: 600,
      origin: "bottom",
    },
  },
  {
    element: ".about-wrapper__info",
    animation: {
      delay: 1000,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".timeline__item",
    animation: {
      delay: 300,
      interval: 150,
      origin: "bottom",
    },
  },
  {
    element: ".skill-card",
    animation: {
      delay: 300,
      interval: 100,
      origin: "bottom",
    },
  },
  {
    element: ".skills-certifications",
    animation: {
      delay: 400,
      origin: "bottom",
    },
  },
  {
    element: ".article-card",
    animation: {
      delay: 250,
      interval: 120,
      origin: "bottom",
    },
  },
  {
    element: ".articles-footer-cta",
    animation: {
      delay: 500,
      origin: "bottom",
    },
  },
  {
    element: ".contact-wrapper",
    animation: {
      delay: 800,
      origin: "bottom",
    },
  },
];
